/**
 * @module サービス追加完了確認表示用コンポーネント
 */
import ThanksPageTitle from './ThanksPageTitle.vue';

export default {
  name: 'ThanksSimpleConfirmation',
  components: {
    ThanksPageTitle,
  },
  data(vm) {
    return {
      pageInfo: this.fromPageInfo,
      contents: 0,
      contentsInfo: [
        {
          id: 0,
          page: 46,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.サービス追加完了'
          ), // FE-CU54-C0023
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サービスを追加しました'
          ), // FE-CU54-C0024
        },
      ],
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        contentsInfo: [
          // ToDo変数名変更
          {
            id: 0,
            page: 46,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.サービス追加完了'
            ), // FE-CU54-C0023
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サービスを追加しました'
            ), // FE-CU54-C0024
          },
        ],
      };
    },
  },
  props: {
    fromPageInfo: {
      type: Object,
      default: {},
      require: false,
    },
  },
  mounted: function () {
    let page = this.pageInfo.page;
    let cont = 0;
    this.contentsInfo.forEach(function (item) {
      if (item.page == page) {
        cont = item.id;
      }
    });
    this.contents = cont;
  },
  /** @type {Methods} */
  methods: {
    /**
     * 画面遷移処理
     * @param {String} url 画面遷移先パス
     */
    replace(url) {
      if (url) {
        this.$router.replace({
          path: url,
        });
      }
    },
  },
};
